<template>
    <div>
        <page-header
        title="Satisfaction Survey"
        breadcrumb="Dashboard > Settings > Messaging > Satisfaction Survey"
      />
       <main class="bg-white p-3">
        <div class="flex items-center">
            <p class="mr-5">Satisfaction Survey</p>
            <p><base-checkbox v-mode="true"/> Satisfaction Survey</p>
          </div>

          <p class="mt-4">
            <b>Customer Satisfaction Survey</b><br/>
            <span>
                This question helps assess the overall satisfaction for the response provided by the agent. Your feedback
                scale is shown, placed at the footer of emails sent to customers. This then links to your CSAT widget which
                you will be customizing below. You can <router-link to="" class="text-primary-yellow">preview</router-link> how it looks.
            </span>
          </p>

          <div class="flex mt-4 justify-between flex-wrap">
            <div class="col-12 col-sm-6 col-md-5 p-0">
                <label class="block w-full mb-4">Survey Question:</label>
                <input class="w-full bg-gray-200 p-2"/>
            </div>
            <div class="col-12 col-sm-6 col-md-5 p-0">
                <label class="w-full flex items-center"> <base-checkbox v-mode="true"/> Message (Subtitle):</label>
                <input class="w-full bg-gray-200 p-2"/>
            </div>
          </div>
          <hr class="mt-3">
          
          <div>
            <div class="w-full justify-between flex py-2 pt-4">
                <b>Feedback Page</b>
                <button @click="showPreviewModal = true" class="px-3 py-2 bg-primary-yellow rounded">Preview</button>
            </div>
            <div>
                Customers are routed to a thank you page upon clicking on a rating. You can gather more information
                here. You can  <router-link to="" class="text-primary-yellow">preview the page here</router-link></div>
          </div>

          <div class="flex mt-4 justify-between flex-wrap">
            <div class="col-12 col-sm-6 col-md-5 p-0">
                <label class="block w-full mb-4">Title:</label>
                <input class="w-full bg-gray-200 p-2"/>
            </div>
            <div class="col-12 col-sm-6 col-md-5 p-0">
                <label class="w-full flex items-center"> <base-checkbox v-mode="true"/> Message (Subtitle):</label>
                <input class="w-full bg-gray-200 p-2"/>
            </div>
          </div>

          <div class="flex mt-4 justify-between flex-wrap">
            <div class="col-12 col-sm-6 col-md-5 p-0">
                <label class="w-full flex items-center"> <base-checkbox v-mode="true"/> Include products dropdown selection</label>
            </div>
            <div class="col-12 col-sm-6 col-md-5 p-0">
                <label class="w-full flex items-center"> <base-checkbox v-mode="true"/> Include additional comments box:</label>
            </div>
          </div>

          <div class="flex mt-4 justify-between flex-wrap">
            <div class="col-12 col-sm-6 col-md-5 p-0">
                <label class="w-full flex items-center font-semibold">Placeholder Text:</label>
                <input class="w-full bg-gray-200 p-2" placeholder="Eg: Select a product"/>
            </div>
            <div class="col-12 col-sm-6 col-md-5 p-0">
                <label class="w-full flex items-center font-semibold">Placeholder Text:</label>
                <input class="w-full bg-gray-200 p-2" placeholder="Eg: Add more details about your experience"/>
            </div>
          </div>


          <div class="mt-4">
            <label class="w-full flex items-center"> <base-checkbox v-mode="true"/> Include additional comments box:</label>
            <div class="border-gray-200 border-2 p-4">
                 <b>Question (Give extra options to streamline feedback):</b>
                 <p class="py-2 px-2 bg-gray-100 my-2">Eg: Which of these contributed to your experience?</p>

                 <div>
                    <b>Answer Options</b><br/>
                    <div class="flex py-2">
                        <label class="radio-label" for="single">
                          <input
                            type="radio"
                            name="mobiletype"
                            id="single"
                            value="mobile"
                            v-model="phoneNumberType"
                          />
                          Single Selection
                          <span></span>
                        </label>
                        <label class="radio-label ml-4" for="multiple">
                          <input
                            type="radio"
                            id="multiple"
                            name="mobiletype"
                            value="fixed"
                            v-model="phoneNumberType"
                          />
                          Multiple Selection
                          <span></span>
                        </label>
                      </div>
                    <input class="w-full max-w-sm p-2 bg-gray-100 my-2 rounded" placeholder="Choice 1"/><br/>
                    <input class="w-full max-w-sm p-2 bg-gray-100 rounded" placeholder="Choice 2"/><br/>
                    <button class="text-primary-yellow py-3">Add</button>
                 </div>
            </div>
          </div>

          <div class="flex flex-wrap mt-4">
            <div class="col-12 col-sm-6 col-sm-5">
               <label>Thank You Message after Feedback Submission:</label><br>
               <input class="w-full p-2 bg-gray-100 rounded"/>
            </div>
            <div class="col-12 col-sm-6 col-sm-5">
                <label>Thank you Image: <tooltip/></label><br/>
                <div class="flex py-2">
                    <label class="radio-label" for="default">
                      <input
                        type="radio"
                        name="image"
                        id="default"
                        value="mobile"
                        v-model="phoneNumberType"
                      />
                      Use Default
                      <span></span>
                    </label>
                    <label class="radio-label ml-4" for="custom">
                      <input
                        type="radio"
                        id="custom"
                        name="image"
                        value="fixed"
                        v-model="phoneNumberType"
                      />
                      Custom
                      <abbr class="text-primary-yellow ml-3">upload</abbr>
                      <span></span>
                    </label>
                  </div>
            </div>
          </div>



          <div class="mt-4">
            <p>Which emails should come with the satisfaction survey link?</p>
            <div class=" py-2">
                    <label class="radio-label" for="allEmail">
                      <input
                        type="radio"
                        name="link"
                        id="allEmail"
                        value="mobile"
                        v-model="phoneNumberType"
                      />
                      All support emails
                      <span></span>
                    </label>
                    <label class="radio-label" for="users">
                      <input
                        type="radio"
                        id="users"
                        name="link"
                        value="fixed"
                        v-model="phoneNumberType"
                      />
                      Allow users add link in specific emails
                      <span></span>
                    </label>
                    <label class="radio-label" for="specific">
                        <input
                          type="radio"
                          id="specific"
                          name="link"
                          value="fixed"
                          v-model="phoneNumberType"
                        />
                        Emails sent from specific categories:
                        <span></span>
                      </label>
                  </div>
          </div>


          
          <div>
            <label class="w-full flex items-center mt-3"> <base-checkbox v-mode="true"/> Emails sent from specific categories:</label>
            <div class="flex flex-wrap col-12 col-sm-10 col-lg-8">
                <b class="col-6"><base-checkbox v-mode="true"/> Enquiries</b>
                <b class="col-6"><base-checkbox v-mode="true"/> Returns</b>
                <b class="col-6"><base-checkbox v-mode="true"/> Technical</b>
                <b class="col-6"><base-checkbox v-mode="true"/> Refunds</b>
            </div>
            <label class="w-full flex items-center mt-3"> <base-checkbox v-mode="true"/> Emails after ticket status is changed to:</label>
            <div class="flex flex-wrap col-12 col-sm-10 col-lg-8">
                <b class="col-6"><base-checkbox v-mode="true"/> Pending</b>
                <b class="col-6"><base-checkbox v-mode="true"/> Closed</b>
                <b class="col-6"><base-checkbox v-mode="true"/> Resolved</b>
                <b class="col-6"><base-checkbox v-mode="true"/> Waiting on Customer</b>
            </div>
            <hr class="my-3">
            <b class="mt-5">Embed Feedback into Your Website</b>
          </div>


          <div class="mt-5">
            <label class="block w-full">Button Text:</label>
            <input class="w-full max-w-sm p-2 bg-gray-100 my-2 rounded" placeholder="Choice 1"/><br/>
          </div>


          <div class="mt-5">
            <label>Widget Position:</label>
            <div class="flex py-2">
                <label class="radio-label" for="Bleft">
                  <input
                    type="radio"
                    name="position"
                    id="Bleft"
                    value="mobile"
                    v-model="phoneNumberType"
                  />
                  Bottom Left
                  <span></span>
                </label>
                <label class="radio-label ml-4" for="Bright">
                  <input
                    type="radio"
                    id="Bright"
                    name="position"
                    value="fixed"
                    v-model="phoneNumberType"
                  />
                  Bottom Right
                  <span></span>
                </label>
                <label class="radio-label ml-4" for="Tleft">
                    <input
                      type="radio"
                      id="Tleft"
                      name="position"
                      value="fixed"
                      v-model="phoneNumberType"
                    />
                    Top Left
                    <span></span>
                  </label>
                  <label class="radio-label ml-4" for="Tright">
                    <input
                      type="radio"
                      id="Tright"
                      name="position"
                      value="fixed"
                      v-model="phoneNumberType"
                    />
                    Top Right
                    <span></span>
                  </label>
              </div>

              <div class="flex flex-wrap col-12 col-sm-10 col-md-9 border-gray-300 border-2 p-3 rounded">
                 <div class="col-12 col-sm-6 p-0">
                    <label>Bottom Offset (in px):</label>
                    <input class="w-full max-w-sm p-2 bg-gray-100 my-2 rounded" placeholder="Choice 1"/><br/>
                 </div>
                 <div class="col-12 col-sm-6 p-0">
                    <label>Bottom Offset (in px):</label>
                    <input class="w-full max-w-sm p-2 bg-gray-100 my-2 rounded" placeholder="Choice 1"/><br/>
                 </div>
                 <div class="col-12 col-sm-6 p-0 mt-2">
                    <label>Background Color:</label><br/>
                    <input type=color placeholder="Choice 1"/><br/>
                 </div>
                 <div class="col-12 col-sm-6 p-0 mt-2">
                    <label>Text Color:</label><br>
                    <input type=color placeholder="Choice 1"/><br/>
                 </div>
              </div>
          </div>



          <div class=" col-12 col-sm-10 col-md-9 p-0 mt-12">
            <p class="py-2">
                Please copy and paste the code below anywhere before the  tag in the html template of your site or every
                page where you'd like to provide the feedback form.
            </p>
             <textarea  class="resize-none h-64 w-full p-3 rounded border-gray-300 border-2">
                &lt;script type=&quot;text/javascript&quot; src=&quot;https://s3.amazonaws.com/assets.freshdesk.com/widget/freshwidget.js&quot;&gt;&lt;/script&gt;
                                 &lt;style type=&quot;text/css&quot; media=&quot;screen, projection&quot;&gt;
                                     @import url(https://s3.amazonaws.com/assets.freshdesk.com/widget/freshwidget.css); 
                                 &lt;/style&gt; 
                                 &lt;iframe title=&quot;Feedback Form&quot; class=&quot;freshwidget-embedded-form&quot; id=&quot;freshwidget-embedded-form&quot; src=&quot;https://newaccount1603282492283.freshdesk.com/widgets/feedback_widget/new?&amp;widgetType=embedded&amp;screenshot=No&quot; scrolling=&quot;no&quot; height=&quot;500px&quot; width=&quot;100%&quot; frameborder=&quot;0&quot; &gt;
                                 &lt;/iframe&gt;
             </textarea>

             <p class="mt-3 mb-2">
                <button class="text-primary-yellow pr-2 border-r-2 border-gray-300">Copy Code</button>
                <button class="ml-2 ">Preview Widget</button>
             </p>
          </div>


          <div>
            <hr/>
            <p class="flex justify-end items-center my-3">
               <button class=" mr-8">Cancel</button>
               <button class="py-2 px-3 bg-primary-yellow rounded">Save</button> 
            </p>
          </div>
       </main>

       <PreviewModal 
       :showModal="showPreviewModal"
       @triggerfeedback="showFeedbackmodal = true"
       @close-modal="showPreviewModal = false" />

       <FeedBackModal 
       :showModal="showFeedbackmodal"
       @triggerThankyou="showThankyouModal = true"
       @close-modal="showFeedbackmodal = false" />

       <ThankyouModal 
       :showModal="showThankyouModal"
       @close-modal="showThankyouModal = false" />
    </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import PreviewModal from "@/components/3pl/Settings/Messaging/modal/PreviewModal.vue"
import FeedBackModal from "@/components/3pl/Settings/Messaging/modal/FeedBackModal.vue"
import ThankyouModal from "@/components/3pl/Settings/Messaging/modal/ThankyouModal.vue"

    export default {
        components: { PageHeader, PreviewModal, FeedBackModal, ThankyouModal },
        data() {
            return {
                showPreviewModal: false,
                showFeedbackmodal: false,
                showThankyouModal: false
            }
        },
    }
</script>

<style lang="scss" scoped>
.radio-label span::after {
    background: #FCC210;
  }
</style>